<ng-container *ngIf="offerSet">

  <ng-container *ngIf="offerSet.enable_contribution_goal">
    <label>
      {{ offerSet.contribution_goal_current_value / 100 | currency: 'USD' : 'symbol' : '1.0-0' }} Raised

      <progress class="blue" [max]="offerSet.contribution_goal / 100" [value]="offerSet.contribution_goal_current_value / 100"></progress>
    </label>

    <p>
      {{ ratio() | percent }} of {{ offerSet.contribution_goal / 100 | currency: 'USD' : 'symbol' : '1.0-0' }}
    </p>
  </ng-container>

  <ng-container *ngIf="!offerSet.enable_contribution_goal">
    <p>This feature is not enabled</p>
  </ng-container>

</ng-container>
